(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
	document.addEventListener('DOMContentLoaded', function(event) {

		let announcementbarSlides = document.querySelectorAll('.announcementbar-slide');

		announcementbarSlides.forEach(announcementbarSlide => {
			if(!global_configs.isPreSaleEnabled && announcementbarSlide.classList.contains('display-behaivor-presale')) {
				announcementbarSlide.remove();
			}

			if(global_configs.isPreSaleEnabled && announcementbarSlide.classList.contains('display-behaivor-regular')) {
				announcementbarSlide.remove();
			}
		});

   	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aside-article"]) return;
  try {
    

  document.addEventListener('DOMContentLoaded', function(event) {
    if(global_configs.isPreSaleEnabled) {
          const el75iSale     = document.getElementById("card-normal-price-75i");
          const el45iSale     = document.getElementById("card-normal-price-45i");


          if(global_configs.is75iPreSale) {
            configuredDiscount = global_configs._75iDiscount.split(",");
            let htmlPrice = el75iSale.textContent;
            discountedPrice = `$${formatPrice(htmlPrice,configuredDiscount[0],configuredDiscount[1])}`;
            
            el75iSale.innerHTML = getCompareSectionDiscountedPriceHTML(htmlPrice,discountedPrice);

          }

          if(global_configs.is45iPreSale) {
            configuredDiscount = global_configs._45iDiscount.split(",");
            let htmlPrice = el45iSale.textContent;
            discountedPrice = `$${formatPrice(htmlPrice,configuredDiscount[0],configuredDiscount[1])}`;

            el45iSale.innerHTML = getCompareSectionDiscountedPriceHTML(htmlPrice,discountedPrice);

          }
    }

    const h2Elements = document.querySelectorAll('.article-template__content h2');
    const tocLinks = document.querySelectorAll('.desktop-content-table .article-content-item a');

    function addIdsToH2Elements(elements) {
        elements.forEach((h2, index) => {
            const idText = h2.textContent
                .trim()
                .toLowerCase()
                .replace(/[^a-z0-9\s-]/g, '')  // Remove special character, exclude "-"
                .replace(/\s+/g, '-');          // Replace spaces with hyphens
            
            h2.id = idText || `section-${index + 1}`;  // Fallback if text is empty
        });
    }
    addIdsToH2Elements(h2Elements);

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            
            tocLinks.forEach((link) => link.classList.remove('active'));

            const id = entry.target.getAttribute('id');
            const activeLink = document.querySelector(`.desktop-content-table .article-content-item a[href="#${id}"]`);
            if (activeLink) activeLink.classList.add('active');
          }
        });
      },
      {
        rootMargin: '0px 0px -80% 0px',
        threshold: 0,
      }
    );

    h2Elements.forEach((h2) => observer.observe(h2));
});

window.addEventListener('DOMContentLoaded', () => {

  const content_article = document.getElementById('content-article');

    if (window.matchMedia('(min-width: 800px)').matches) {
      return
    }

    const handleCollapse = (content_article) => {
      if (content_article.classList.contains('block-collapsed')) {
        content_article.classList.remove('block-collapsed');
        content_article.setAttribute('aria-expanded', 'true');
      } else {
        content_article.classList.add('block-collapsed');
        content_article.setAttribute('aria-expanded', 'false');
      }
    }

    document.querySelectorAll('.content-article-title').forEach((content_article, index) => {
      content_article.classList.add('block-collapsed');
      content_article.setAttribute('aria-expanded', 'false');
      content_article.setAttribute('tabindex', '0');

      content_article.nextElementSibling.setAttribute('id', `content-article-title-${index}`);
      content_article.setAttribute('aria-controls', `content-article-title-${index}`);

      content_article.addEventListener('click', () => { handleCollapse(content_article) });
      content_article.addEventListener('keypress',  () => { handleCollapse(content_article) });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collapsible-content"] && !Shopify.designMode) return;
  try {
    
/* Custom Code: Make Collapsible Tab Only Open One Tab At A Time */
let collapsibles = document.querySelectorAll(".collapsible-content .page-width .grid__item .accordion details");
collapsibles.forEach((collapsible)=>{
  collapsible.addEventListener("click", function() {
    collapsibles.forEach((element)=>{
      if (element.hasAttribute("open")) {
        element.removeAttribute("open")
      }
    })
  });
})
/* End Custom Code: Make Collapsible Tab Only Open One Tab At A Time */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-slider"] && !Shopify.designMode) return;
  try {
    
	document.addEventListener('DOMContentLoaded', function(event) {
		if(global_configs.isPreSaleEnabled == false) {
			const preSaleBadges = document.querySelectorAll('.pre-sale-badge');

			if(preSaleBadges) {
				preSaleBadges.forEach(badge => {
					badge.style.display = 'none';
				});
			}
		}

		let collectionSliderSections = document.querySelectorAll('.collection-slider-container');

		collectionSliderSections.forEach(collectionSliderSection => {
			if(!global_configs.isPreSaleEnabled && collectionSliderSection.classList.contains('display-behaivor-presale')) {
				collectionSliderSection.remove();
			}

			if(global_configs.isPreSaleEnabled && collectionSliderSection.classList.contains('display-behaivor-regular')) {
				collectionSliderSection.remove();
			}
		});

   	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["compare-new"] && !Shopify.designMode) return;
  try {
    
	document.addEventListener('DOMContentLoaded', function(event) {
		if(global_configs.isPreSaleEnabled) {

			const El75Price = document.getElementById('section-compare-price-75i');
			const El45Price = document.getElementById('section-compare-price-45i');

			let discountedPrice;

			if(El75Price && global_configs.is75iPreSale) {
				configuredDiscount = global_configs._75iDiscount.split(",");
				discountedPrice = `$${formatPrice(El75Price.textContent,configuredDiscount[0],configuredDiscount[1])}`;
				El75Price.innerHTML = discountedPrice;
			}

			if(El45Price && global_configs.is45iPreSale) {
				configuredDiscount = global_configs._45iDiscount.split(",");
				discountedPrice = `$${formatPrice(El45Price.textContent,configuredDiscount[0],configuredDiscount[1])}`;
				El45Price.innerHTML = discountedPrice;
			}
		}
  	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["compare-products-pdp"] && !Shopify.designMode) return;
  try {
    
	document.addEventListener('DOMContentLoaded', function(event) {
		if(global_configs.isPreSaleEnabled) {

			const El75Price = document.getElementById('section-compare-price-75i');
			const El45Price = document.getElementById('section-compare-price-45i');

			let discountedPrice;

			if(El75Price && global_configs.is75iPreSale) {
				configuredDiscount = global_configs._75iDiscount.split(",");
				discountedPrice = `$${formatPrice(El75Price.textContent,configuredDiscount[0],configuredDiscount[1])}`;
				El75Price.innerHTML = getCompareSectionDiscountedPriceHTML(El75Price.textContent,discountedPrice);
			}

			if(El45Price && global_configs.is45iPreSale) {
				configuredDiscount = global_configs._45iDiscount.split(",");
				discountedPrice = `$${formatPrice(El45Price.textContent,configuredDiscount[0],configuredDiscount[1])}`;
				El45Price.innerHTML = getCompareSectionDiscountedPriceHTML(El45Price.textContent,discountedPrice);
			}
		}
  	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown"] && !Shopify.designMode) return;
  try {
    
	var countDownDate = new Date(countDownInputDate + " UTC").getTime(); 
  
	var timezoneOffsetHours = -6; 

	var myfunc = setInterval(function () {
		var now = new Date().getTime();
		var adjustedNow = now + timezoneOffsetHours * 3600000;
		var timeleft = countDownDate - adjustedNow;

		var days = Math.floor(timeleft / (1000 * 60 * 60 * 24));
		var hours = Math.floor((timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
		var minutes = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));
		var seconds = Math.floor((timeleft % (1000 * 60)) / 1000);

		document.getElementById("days").innerHTML = ("0" + days).slice(-2) + " : ";
		document.getElementById("hours").innerHTML = ("0" + hours).slice(-2) + " : ";
		document.getElementById("mins").innerHTML = ("0" + minutes).slice(-2) + " : ";
		document.getElementById("secs").innerHTML = ("0" + seconds).slice(-2) + "";

		if (timeleft < 0) {
			clearInterval(myfunc);
			document.getElementById("days").innerHTML = "00";
			document.getElementById("hours").innerHTML = "00";
			document.getElementById("mins").innerHTML = "00";
			document.getElementById("secs").innerHTML = "00";
		}
	}, 1000);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-reasons-to-love"] && !Shopify.designMode) return;
  try {
    

  var slideIndex = 1;

  var btnPrev = document.querySelector(".slider-arrow-left");

  btnPrev.addEventListener("click", function() {
    sliderToggle(-1);
  });

  var btnNext = document.querySelector(".slider-arrow-right");

  btnNext.addEventListener("click", function() {
    sliderToggle(1);
  });

  let btnsIndicator = document.querySelectorAll('.slider-indicator');
  
  btnsIndicator.forEach((element) => {
    element.addEventListener('click', function(event) {
      currentDiv(this.getAttribute("index"));
    });
  });
  
  showDivs(slideIndex);

  function sliderToggle(n) {
    showDivs(slideIndex += n);
  }

  function sliderAutoToggle() {
   sliderToggle(1);

    setTimeout(() => {
      sliderAutoToggle();
    }, "3000");
  }
  
  function currentDiv(n) {
    showDivs(slideIndex = n);
  }

  function showDivs(n) {
    var i;
    
    var x = document.getElementsByClassName("slider-item");
    
    var dots = document.getElementsByClassName("slider-indicator");
    
    if (n > x.length) {slideIndex = 1}
    
    if (n < 1) {slideIndex = x.length}
    
    for (i = 0; i < x.length; i++) {
      x[i].style.display = "none";  
    }
    
    for (i = 0; i < dots.length; i++) {
      dots[i].className = dots[i].className.replace(" slider-indicator-active", "");
    }
    
    x[slideIndex-1].style.display = "flex";  
    dots[slideIndex-1].className += " slider-indicator-active";
    
  }

  setTimeout(() => {
    sliderAutoToggle();
  }, "3000");

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["digioh-results-v2"] && !Shopify.designMode) return;
  try {
    
   	document.addEventListener('DOMContentLoaded', function(event) {
  if(global_configs.isPreSaleEnabled == false) {
  	const preSaleBadges = document.querySelectorAll('.pre-sale-badge');

  	if(preSaleBadges) {
  		preSaleBadges.forEach(badge => {
  			badge.style.display = 'none';
  		});
  	}

  	const elPsCards = document.querySelectorAll(".imp-pre-sale-card-bundle-ps");

  	if(elPsCards) {
  		elPsCards.forEach(card => {
  			card.style.display = 'none';
  		});
  	}
  } else {
  	const elBgCards = document.querySelectorAll(".imp-pre-sale-card-bundle-bg");

  	if(elBgCards) {
  		elBgCards.forEach(card => {
  			card.style.display = 'none';
  		});
  	}
  }
   	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["discovery-product-info"] && !Shopify.designMode) return;
  try {
    

    document.addEventListener('DOMContentLoaded', function(event) {
		if(global_configs.isPreSaleEnabled) {

			let productTitle = document.querySelector('.utopiair-product-title').textContent;
            const imageBadgePromo = document.getElementById("promo-badge_discovery");
            imageBadgePromo.style.display = 'block';

      // PRESALE - CONFIG - 3
			if(productTitle.toLowerCase().includes('75i') || productTitle.toLowerCase().includes('45i') || productTitle.toLowerCase().includes('flex')) {
				let el = document.getElementById("discovery-normal-price");
				let elSticky = document.getElementById("sticky-bar-price");

				let elCardPrice;
				let elCardCompare;
				let configuredDiscount;
				let discountedPrice;

				let htmlPrice = el.textContent;

				const normalPrice = parseFloat(htmlPrice.replace(/[^\d.-]/g, ''));

				//TODO: Nos quedamos en poner aqui los strike to price como en el main collection

				if(global_configs.is75iPreSale && productTitle.toLowerCase().includes('75i') && productTitle.toLowerCase().indexOf('Refurbished') == -1) {
				configuredDiscount = global_configs._75iDiscount.split(",");

				discountedPrice = `$${formatPrice(htmlPrice,configuredDiscount[0],configuredDiscount[1])}`;

				} else if(global_configs.is45iPreSale && productTitle.toLowerCase().includes('45i') && productTitle.toLowerCase().indexOf('Refurbished') == -1) {
				configuredDiscount = global_configs._45iDiscount.split(",");

				discountedPrice = `$${formatPrice(htmlPrice,configuredDiscount[0],configuredDiscount[1])}`;
				} else if(global_configs.isFlexPreSale && productTitle.toLowerCase().includes('flex') && productTitle.toLowerCase().indexOf('Refurbished') == -1) {
				configuredDiscount = global_configs._flexDiscount.split(",");

				discountedPrice = `$${formatPrice(htmlPrice,configuredDiscount[0],configuredDiscount[1])}`;
				}

				if(configuredDiscount.length > 1) {
				el.innerHTML = `${discountedPrice} <strike style="color:gray"; data-class="is-showing">${htmlPrice}</strike>`;
				elSticky.innerHTML = `${discountedPrice} <strike style="color:gray"; data-class="is-showing">${htmlPrice}</strike>`;
				}

			}
		}
  	});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["discovery-sticky-bar-new"] && !Shopify.designMode) return;
  try {
    
	//PRE-SALE CONFIG
	document.addEventListener('DOMContentLoaded', function(event) {

		if(global_configs.isPreSaleEnabled) {
			const discoveryPriceEl = document.querySelector('.discovery-bar__product-price');
			const stickyBarPriceEl = document.querySelector('.discovery-sticky-bar__product-price');
			const productTitle     = document.querySelector('.display.display--large.discovery-bar__title').innerHTML.trim();

			let discoveryPriceText = discoveryPriceEl.textContent.trim();
			let discoveryPrice = parseFloat(discoveryPriceText.replace('From $', ''));

			let stickyPriceText = stickyBarPriceEl.textContent.trim();
			stickyPriceText = stickyPriceText.replace('From ', '');
			let stickyPrice = parseFloat(stickyPriceText.replace('$', ''));
			let discountData;
			let productSuffix;

			if(productTitle.toLowerCase().includes('75i')) {
				discountData = global_configs._75iDiscount.split(",");
				productSuffix = '75i';
			}

			if(productTitle.toLowerCase().includes('45i')) {
				discountData = global_configs._45iDiscount.split(",");
				productSuffix = '45i';
			}

			if(productTitle.toLowerCase().includes('35i')) {
				discountData = global_configs._35iDiscount.split(",");
				productSuffix = '35i';
			}


			htmlPrice = `From $${formatPrice(stickyPriceText,discountData[0],discountData[1])} <strike id="discovery-price-${productSuffix}" style="color:gray;" data-class="is-showing" class="product-price--compared js-product-compare-price inline-block mls compare-price--grid ">${stickyPriceText}</strike>`;

			discoveryPriceEl.innerHTML = htmlPrice;
			stickyBarPriceEl.innerHTML = htmlPrice;
		}
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dynamic-faqs"] && !Shopify.designMode) return;
  try {
    
/* Custom Code: Make Collapsible Tab Only Open One Tab At A Time */
let collapsibles = document.querySelectorAll(".collapsible-content .page-width .grid__item .accordion details");
collapsibles.forEach((collapsible)=>{
  collapsible.addEventListener("click", function() {
    collapsibles.forEach((element)=>{
      if (element.hasAttribute("open")) {
        element.removeAttribute("open")
      }
    })
  });
})
/* End Custom Code: Make Collapsible Tab Only Open One Tab At A Time */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-legacy"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-meganav"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  class RebuyHeaderLoadingState {
    constructor(stickyHeader) {
      this.stickyHeader = stickyHeader;
      this.searches = stickyHeader.querySelectorAll('.header__search.rebuy-search-loading');
      this.carts = stickyHeader.querySelectorAll('.header__icon--cart.rebuy-cart-loading');
      if (!this.searches.length && !this.carts.length) return;

      if (this.isReady()) {
        this.cleanup();
        return;
      }

      this.observer = new MutationObserver(() => {
        if (this.isReady()) this.cleanup();
      });
      this.observer.observe(this.stickyHeader, { childList: true, subtree: true });
      this.timeout = window.setTimeout(() => this.cleanup(), 5000);
    }

    isReady() {
      return this.stickyHeader.querySelector('.rebuy-quick-view-dropdown .rebuy-quick-view__product-list');
    }

    cleanup() {
      if (this.observer) this.observer.disconnect();
      if (this.timeout) window.clearTimeout(this.timeout);
      this.searches.forEach((search) => search.classList.remove('rebuy-search-loading'));
      this.carts.forEach((cart) => cart.classList.remove('rebuy-cart-loading'));
    }
  }

  document.querySelectorAll('sticky-header, .header-wrapper:not(sticky-header)').forEach((headerWrapper) => new RebuyHeaderLoadingState(headerWrapper));

  	document.addEventListener('DOMContentLoaded', function(event) {
		if (globalPresaleEnabled) {
			let headerBadges = document.querySelectorAll(".header__badge");

			if (global_configs.isPreSaleEnabled) {
				headerBadges.forEach((headerBadge) => {
					if (!headerBadge.classList.contains("presale-badge")) {
						headerBadge.remove();
					}
				});

			} else {
				headerBadges.forEach((headerBadge) => {
					if (headerBadge.classList.contains("presale-badge")) {
						headerBadge.remove();
					}
				});
			}

			let productImgBadges = document.querySelectorAll(".badge-img");

			if (!global_configs.isPreSaleEnabled) {
				productImgBadges.forEach((productImgBadge) => {
					if (productImgBadge.classList.contains("presale-badge")) {
						productImgBadge.remove();
					}
				});

			}
		} else {
          let headerBadges = document.querySelectorAll(".header__badge");

          headerBadges.forEach((headerBadge) => {
              if (headerBadge.classList.contains("presale-badge")) {
                  headerBadge.remove();
              }
          });

          let productImgBadges = document.querySelectorAll(".badge-img");

          productImgBadges.forEach((productImgBadge) => {
              if (productImgBadge.classList.contains("presale-badge")) {
                  productImgBadge.remove();
              }
          });
        } 
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-customizable-slider"] && !Shopify.designMode) return;
  try {
    
/*$(window).on("load", function () {
  $('.hero-custom-slider').slick({
    arrows: true,
          autoplay: false,
    dots: true,
    autoplaySpeed: 10000,
    fade: false,
          adaptiveHeight: true,
    cssEase: 'linear'
  });
      $(".banner-prev-btn").click(function () {
    $(".hero-custom-slider").slick("slickPrev");
  });
  $(".banner-next-btn").click(function () {
    $(".hero-custom-slider").slick("slickNext");
  });
});*/

	document.addEventListener("DOMContentLoaded", () => {
		const section = document.querySelector("section.banner-countdown");

        const today = new Date();
    	const isTargetDate = today.getFullYear() === 2025;

        if(isTargetDate) {
          section.innerHTML = `
              <canvas id="fireworksCanvas" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"></canvas>
              <span class="new-year-span">Happy</span>
              <div class="hero-container" style="margin-left: 25px;">
                  <span class="hero">
                      <span>2025</span>
                  </span>
              </div>
          `;
  
          section.style.position = "relative";
          section.style.overflow = "visible";
          section.style.height = "300px";
          section.classList.add("fireworks");
  
          const container = document.querySelector('#fireworksCanvas')
          const fireworks = new Fireworks.default(container)
          fireworks.start()
        }
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-ut-collection"] && !Shopify.designMode) return;
  try {
    

	$('.utopiair-collection-slider').slick({
		infinite: true,
		arrows: true,
		dots: true,
		slidesToShow: 3,
		adaptiveHeight: true,
		responsive: [
			{
			breakpoint: 900,
			settings: {
				slidesToShow: 2
			}
			},
			{
			breakpoint: 640,
			settings: {
				slidesToShow: 1
			}
			}
		]
	});

	$(".collection-prev-btn").click(function () {
		$(".utopiair-collection-slider").slick("slickPrev");
	});

	$(".collection-next-btn").click(function () {
		$(".utopiair-collection-slider").slick("slickNext");
	});


	document.addEventListener('DOMContentLoaded', function(event) {
		if(global_configs.isPreSaleEnabled) {
			let firstPopPrice = document.getElementById("imp-pop-price-45i").innerHTML.trim();
			let secondPopPrice = document.getElementById("imp-pop-price-75i").innerHTML.trim();

			const cardClasses = ['.section-on-sale-bundle-bg'];

			cardClasses.forEach((cardClass) => {
				const cardElements = document.querySelectorAll(cardClass);

				cardElements.forEach((cardElement) => {
					cardElement.style.display = 'none';
				});
			});

			let elCardPrice;
			let elCardCompare;
			let newSpan;

      		if(global_configs.is75iPreSale) {

				elCardPrice = document.getElementById("card-normal-price-75i");
				elCardCompare = document.getElementById("card-compare-at-price-75i");
				let _75iDiscount = global_configs._75iDiscount.split(",");

				if(!elCardCompare) {
					newSpan = document.createElement('span');

					newSpan.innerHTML = `<strike id="card-compare-at-price-75i" data-class="is-showing" class="product-price--compared js-product-compare-price compare-price--grid ">${elCardPrice.textContent}</strike>`;
					newSpan.className = 'inline-block mls';

					elCardPrice.parentNode.appendChild(newSpan);
				} else {
					elCardCompare.innerHTML = elCardPrice.innerHTML.trim();
				}

				elCardPrice.innerHTML = `$${formatPrice(elCardPrice.textContent,_75iDiscount[0],_75iDiscount[1])}`;
      		}

			if(global_configs.is45iPreSale) {

				elCardPrice = document.getElementById("card-normal-price-45i");
				elCardCompare = document.getElementById("card-compare-at-price-45i");
				let _45iDiscount = global_configs._45iDiscount.split(",");

				if(!elCardCompare) {
					newSpan = document.createElement('span');

					newSpan.innerHTML = `<strike id="card-compare-at-price-45i" data-class="is-showing" class="product-price--compared js-product-compare-price compare-price--grid ">${elCardPrice.textContent}</strike>`;
					newSpan.className = 'inline-block mls';

					elCardPrice.parentNode.appendChild(newSpan);
				} else {
					elCardCompare.innerHTML = elCardPrice.innerHTML.trim();
				}

				elCardPrice.innerHTML = `$${formatPrice(elCardPrice.textContent,_45iDiscount[0],_45iDiscount[1])}`;
			}

			if(global_configs.is35iPreSale) {

				elCardPrice = document.getElementById("card-normal-price-35i");
				elCardCompare = document.getElementById("card-compare-at-price-35i");
				let _35iDiscount = global_configs._35iDiscount.split(",");

				if(!elCardCompare) {
					newSpan = document.createElement('span');

					newSpan.innerHTML = `<strike id="card-compare-at-price-35i" data-class="is-showing" class="product-price--compared js-product-compare-price compare-price--grid ">${elCardPrice.textContent}</strike>`;
					newSpan.className = 'inline-block mls';

					elCardPrice.parentNode.appendChild(newSpan);
				} else {
					elCardCompare.innerHTML = elCardPrice.innerHTML.trim();
				}

				elCardPrice.innerHTML = `$${formatPrice(elCardPrice.textContent,_35iDiscount[0],_35iDiscount[1])}`;
			}

			if(global_configs.isFlexPreSale) {
				elCardPrice = document.getElementById("card-normal-price-FLEX");
				elCardCompare = document.getElementById("card-compare-at-price-FLEX");
				let _flexDiscount = global_configs._flexDiscount.split(",");

				if(!elCardCompare) {
					newSpan = document.createElement('span');

					newSpan.innerHTML = `<strike id="card-compare-at-price-FLEX" data-class="is-showing" class="product-price--compared js-product-compare-price compare-price--grid ">${elCardPrice.textContent}</strike>`;
					newSpan.className = 'inline-block mls';

					elCardPrice.parentNode.appendChild(newSpan);
				} else {
					elCardCompare.innerHTML = elCardPrice.innerHTML.trim();
				}

				elCardPrice.innerHTML = `$${formatPrice(elCardPrice.textContent,_flexDiscount[0],_flexDiscount[1])}`;
			}

		} else {
			const cardClasses = ['.section-on-sale-75i', '.section-on-sale-45i', '.section-on-sale-35i', '.section-on-sale-bundle-ps'];

			cardClasses.forEach((cardClass) => {
				const cardElements = document.querySelectorAll(cardClass);

				cardElements.forEach((cardElement) => {
					cardElement.style.display = 'none';
				});
			});
     	}
  });

  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-ut-popular"] && !Shopify.designMode) return;
  try {
    
	$('.landing-75i-slider').slick({
		arrows: false,
        autoplay: true,
		speed: 400,
		fade: true,
		cssEase: 'ease-in-out',
		pauseOnHover: false
	});

	$('.landing-45i-slider').slick({
		arrows: false,
        autoplay: true,
		speed: 400,
		fade: true,
		cssEase: 'ease-in-out',
		pauseOnHover: false
	});

	var acc = document.getElementsByClassName("css-accordion");
    var i;
	for (i = 0; i < acc.length; i++) {
		acc[i].addEventListener("click", function() {
			this.classList.toggle("active");

			if(this.classList.contains('active')) {
				this.querySelector('.landing-accordion-arrow-down').classList.add('display-none');
				this.querySelector('.landing-accordion-arrow-up').classList.remove('display-none');
			}
			else {
				this.querySelector('.landing-accordion-arrow-down').classList.remove('display-none')
				this.querySelector('.landing-accordion-arrow-up').classList.add('display-none')
			}

			/* Toggle between hiding and showing the active panel */
			var panel = this.previousElementSibling;
			if (panel.style.display === "block") {
			panel.style.display = "none";
			} else {
			panel.style.display = "block";
			}
		});
	}

	document.addEventListener('DOMContentLoaded', function(event) {
		if(global_configs.isPreSaleEnabled) {
            const preSaleHomeBanner = document.querySelector('.bg-hero-banner');
            const currentHomeBanner = document.querySelector('.hero-customizable-banner');

            if (currentHomeBanner) {
                currentHomeBanner.style.display = 'none';
            }

            if (preSaleHomeBanner) {
                preSaleHomeBanner.style.display = 'block';
            }


			let firstPopPrice = document.getElementById("imp-pop-price-45i").innerHTML.trim();
			let secondPopPrice = document.getElementById("imp-pop-price-75i").innerHTML.trim();

			let _45iDiscount = global_configs._45iDiscount.split(",");
			let _75iDiscount = global_configs._75iDiscount.split(",");


      		// PRESALE - CONFIG - 5
			document.getElementById("imp-pop-price-45i").innerHTML = `$${formatPrice(firstPopPrice,_45iDiscount[0],_45iDiscount[1])} <strike style="color:gray; font-weight: 500;" data-class="is-showing">${firstPopPrice}</strike>`;
			document.getElementById("imp-pop-price-75i").innerHTML = `$${formatPrice(secondPopPrice,_75iDiscount[0],_75iDiscount[1])} <strike style="color:gray; font-weight: 500;" data-class="is-showing">${secondPopPrice}</strike>`;


		}
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-ut-press"] && !Shopify.designMode) return;
  try {
    
	// var slider_press = tns({
	// 	container: '.utopiair-press-slider',
	// 	items: 2,
	// 	arrowKeys: true,
	// 	mouseDrag: true, 
	// 	controlsContainer: '#customize-press-controls',
	// 	navContainer: '#customize-press-nav',
	// 	navAsThumbnails: true,
	// 	lazyload: true
	// });

	$('.utopiair-press-slider').slick({
		infinite: true,
		arrows: true,
		dots: true,
		slidesToShow: 2,
	});

	$(".press-prev-btn").click(function () {
		$(".utopiair-press-slider").slick("slickPrev");
	});

	$(".press-next-btn").click(function () {
		$(".utopiair-press-slider").slick("slickNext");
	});

  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-ut-slider"] && !Shopify.designMode) return;
  try {
    

	function initHomeUtSlider() {
		$('.utopiair-features-slider').slick({
			arrows: false,
			dots: true,
			speed: 400,
			fade: false,
			cssEase: 'linear'
		});
		$(".features-prev-btn").click(function () {
			$(".utopiair-features-slider").slick("slickPrev");
		});

		$(".features-next-btn").click(function () {
			$(".utopiair-features-slider").slick("slickNext");
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initHomeUtSlider);
	} else {
		initHomeUtSlider();
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    

	async function handleCartItems(applyInterval = false) {
		try {

      return null;

			if (!global_configs.isPreSaleEnabled) {
				return;
			}

			const cartItems = await getCartItems();

			const currencyOpt = { style: 'currency', currency: 'USD' };
			const totalElement = document.getElementById("imp-cart-total");

			if (!totalElement) {
				return;
			}

			let totalPrice = 0;
			let count = 1;

			for (const item of cartItems.items) {

				const properties = item.properties || {};

				const price = parseFloat(item.original_price) / 100;
				const hasPresaleDiscount = properties['_presale_discount'] === "true";
				const productType = properties['_shopify_product_type'];

				const cartItemRow = document.getElementById(`CartItem-${count}`);
				if (!cartItemRow) {
					count++;
					continue;
				}

				const oldPriceElement = cartItemRow.querySelector('.cart-item__old-price.price--end');
				const newPriceElement = cartItemRow.querySelector('dd.price--end');

				if (!oldPriceElement || !newPriceElement) {
					totalPrice += price * item.quantity;
					count++;
					continue;
				}

				count++;

				if (hasPresaleDiscount && productType === 'Air Purifier') {
					let discountedPrice = 0;
					let configuredDiscount = null;

					if (item.product_title.includes('75i') && global_configs.is75iPreSale) {
						configuredDiscount = global_configs._75iDiscount?.split(',');
					} else if (item.product_title.includes('45i') && global_configs.is45iPreSale) {
						configuredDiscount = global_configs._45iDiscount?.split(',');
					} else if (item.product_title.includes('35i') && global_configs.is35iPreSale) {
						configuredDiscount = global_configs._35iDiscount?.split(',');
					} else if (item.product_title.includes('FLEX') && global_configs.isFlexPreSale) {
						configuredDiscount = global_configs._flexDiscount?.split(',');
					}

					if (configuredDiscount && configuredDiscount.length >= 2) {
						discountedPrice = calculateDiscountedPrice(
							configuredDiscount[1],
							price,
							item.quantity,
							configuredDiscount[0]
						);

						const rowPrice = (price * item.quantity).toLocaleString('en-US', currencyOpt);
						oldPriceElement.textContent = rowPrice;
						newPriceElement.textContent = discountedPrice.toLocaleString('en-US', currencyOpt);

						totalPrice += discountedPrice;
						continue;
					}
				}

				totalPrice += price * item.quantity;
			}

			const formattedTotal = totalPrice.toLocaleString('en-US', currencyOpt);

			if (applyInterval) {
				const intervalId = setInterval(() => {
					const currentTotalElement = document.getElementById("imp-cart-total");
					if (currentTotalElement) {
					currentTotalElement.textContent = `${formattedTotal} USD`;
					setEventToQtyBtns();
					setEventToQtyInputs();
					}
					clearInterval(intervalId);
					handleCartItems();
				}, 1000);
			} else {
				totalElement.textContent = `${formattedTotal} USD`;
			}

			const cartEmptyEl = document.querySelector('.cart__warnings');
			if (cartEmptyEl && window.getComputedStyle(cartEmptyEl).display === 'none') {
				const msgSpan = document.getElementById('imp-msg-span');
				if (msgSpan) msgSpan.style.display = 'block';
			}
		} catch (error) {
			console.error(">>> ERROR - Detalles del error:", error);
		}
	}

  function calculateDiscountedPrice(discountType,price,qty,discount)
  {
    if(discountType == '%') {
      discountFactor = (100 - discount) / 100;
      discountedPrice = (price * qty) * discountFactor;
    } else {
      discountedPrice = (price * qty) - discount;
    }

    return discountedPrice;
  }

  function setEventToQtyBtns()
  {
      const buttons = document.querySelectorAll('.quantity__button.no-js-hidden');

      buttons.forEach(button => {
          button.addEventListener('click', async function() {
            setTimeout(async () => {
                await handleCartItems(true);
            }, 500);
          });
      });
  }

  function setEventToQtyInputs() {
    const inputs = document.querySelectorAll('.quantity__input');

    inputs.forEach(input => {
        input.addEventListener('change', async function() {
            setTimeout(async () => {
                await handleCartItems(true);
            }, 500);
        });
    });
}

  document.addEventListener('DOMContentLoaded', async function(event) {
      if (global_configs.isPreSaleEnabled) {
          setEventToQtyBtns();
          setEventToQtyInputs()

          await handleCartItems();
      }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-filter-pack-pdp"]) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function(event) {

        addPromoBadgesToPDPGallery();

        const showPromoPrice = document.getElementById("shopify-show-promo-price").value;

        const productTitle 	 	 = document.querySelector(".product__title h1").textContent;
        const model = productTitle.trim().split(" ").pop();

        const productType 	 = document.getElementById("shopify-product-type").value;
        const isPreSaleProduct = document.getElementById('shopify-is-presale-product').value;

        const el = document.querySelector(".price-item.price-item--regular.pdp-price");


        if(global_configs.isPreSaleEnabled) {
            // PRESALE - CONFIG - 4
            if(isPreSaleProduct) {

                let presaleInput = document.getElementById("imp-pre-sale-input");
                if(document.getElementById('imp-pre-sale-input')) {
                    presaleInput.value = "true";
                } else {
                    let presaleInput = document.getElementById("imp-pre-sale-input");
                    presaleInput.value = "true";
                }

                if(showPromoPrice !== 'true') {
                    const priceElements = document.getElementsByClassName("shopify-discount-badge-dc");
                    const discountMessage = getDiscountBadge(model,'presale');

                    if (priceElements.length > 0 && discountMessage) {
                        Array.from(priceElements).forEach((priceElement) => {
                            priceElement.appendChild(discountMessage);
                        });
                    }

                    return;
                }

                const productTypeInput  = document.getElementById("imp-product-type");
                let htmlPrice = el.textContent

                const discountedPrice = getDiscountedPrice(model,htmlPrice,'presale');

                productTypeInput.value = productType;

                if(discountedPrice === null || discountedPrice === undefined || discountedPrice === '') {
                    el.innerHTML = `${htmlPrice}`;
                } else {
                    el.innerHTML = `${discountedPrice} <strike style="color:gray; font-size:20px; font-weight: 300;" data-class="is-showing">${htmlPrice}</strike>`;

                    const newSpan = document.createElement('span');

                    newSpan.innerHTML = global_configs._pre_sale_label;
                    newSpan.className = 'badge';

                    newSpan.style.backgroundColor = 'var(--orange)';
                    newSpan.style.color = 'white';
                    newSpan.style.marginLeft = '10px';

                    el.parentNode.appendChild(newSpan);
                }
             }
        } else {
            if(showPromoPrice !== 'true') {
                const priceElements = document.getElementsByClassName("shopify-discount-badge-dc");
                const discountMessage = getDiscountBadge(model);

                if (priceElements.length > 0 && discountMessage) {
                    Array.from(priceElements).forEach((priceElement) => {
                        priceElement.appendChild(discountMessage);
                    });
                }
                return;
            }

            const productTypeInput  = document.getElementById("imp-product-type");

            let htmlPrice = el.textContent

            const discountedPrice = getDiscountedPrice(model,htmlPrice);

            productTypeInput.value = productType;

            if(discountedPrice === null || discountedPrice === undefined || discountedPrice === '') {
                el.innerHTML = `${htmlPrice}`;
            } else {
                el.innerHTML = `${discountedPrice} <strike style="color:gray; font-size:20px; font-weight: 300;" data-class="is-showing">${htmlPrice}</strike>`;

                const newSpan = document.createElement('span');

                newSpan.innerHTML = 'On Sale';
                newSpan.className = 'badge';

                newSpan.style.backgroundColor = 'var(--orange)';
                newSpan.style.color = 'white';
                newSpan.style.marginLeft = '10px';

                el.parentNode.appendChild(newSpan);
            }
        }
        updateTotalAddCart();
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-filter-pdp-v3"]) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function(event) {

        addPromoBadgesToPDPGallery();

        const showPromoPrice = document.getElementById("shopify-show-promo-price").value;

        const productTitle 	 	 = document.querySelector(".product__title h1").textContent;
        const model = productTitle.trim().split(" ").pop();

        const productType 	 = document.getElementById("shopify-product-type").value;
        const isPreSaleProduct = document.getElementById('shopify-is-presale-product').value;

        const el = document.querySelector(".price-item.price-item--regular.pdp-price");


        if(global_configs.isPreSaleEnabled) {
            // PRESALE - CONFIG - 4
            if(isPreSaleProduct) {

                let presaleInput = document.getElementById("imp-pre-sale-input");
                if(document.getElementById('imp-pre-sale-input')) {
                    presaleInput.value = "true";
                } else {
                    let presaleInput = document.getElementById("imp-pre-sale-input");
                    presaleInput.value = "true";
                }

                if(showPromoPrice !== 'true') {
                    const priceElements = document.getElementsByClassName("shopify-discount-badge-dc");
                    const discountMessage = getDiscountBadge(model,'presale');

                    if (priceElements.length > 0 && discountMessage) {
                        Array.from(priceElements).forEach((priceElement) => {
                            priceElement.appendChild(discountMessage);
                        });
                    }

                    return;
                }

                const productTypeInput  = document.getElementById("imp-product-type");
                let htmlPrice = el.textContent

                const discountedPrice = getDiscountedPrice(model,htmlPrice,'presale');

                productTypeInput.value = productType;

                if(discountedPrice === null || discountedPrice === undefined || discountedPrice === '') {
                    el.innerHTML = `${htmlPrice}`;
                } else {
                    el.innerHTML = `${discountedPrice} <strike style="color:gray; font-size:20px; font-weight: 300;" data-class="is-showing">${htmlPrice}</strike>`;

                    const newSpan = document.createElement('span');

                    newSpan.innerHTML = global_configs._pre_sale_label;
                    newSpan.className = 'badge';

                    newSpan.style.backgroundColor = 'var(--orange)';
                    newSpan.style.color = 'white';
                    newSpan.style.marginLeft = '10px';

                    el.parentNode.appendChild(newSpan);
                }
             }
        } else {
            if(showPromoPrice !== 'true') {
                const priceElements = document.getElementsByClassName("shopify-discount-badge-dc");
                const discountMessage = getDiscountBadge(model);

                if (priceElements.length > 0 && discountMessage) {
                    Array.from(priceElements).forEach((priceElement) => {
                        priceElement.appendChild(discountMessage);
                    });
                }
                return;
            }

            const productTypeInput  = document.getElementById("imp-product-type");

            let htmlPrice = el.textContent

            const discountedPrice = getDiscountedPrice(model,htmlPrice);

            productTypeInput.value = productType;

            if(discountedPrice === null || discountedPrice === undefined || discountedPrice === '') {
                el.innerHTML = `${htmlPrice}`;
            } else {
                el.innerHTML = `${discountedPrice} <strike style="color:gray; font-size:20px; font-weight: 300;" data-class="is-showing">${htmlPrice}</strike>`;

                const newSpan = document.createElement('span');

                newSpan.innerHTML = 'On Sale';
                newSpan.className = 'badge';

                newSpan.style.backgroundColor = 'var(--orange)';
                newSpan.style.color = 'white';
                newSpan.style.marginLeft = '10px';

                el.parentNode.appendChild(newSpan);
            }
        }
        updateTotalAddCart();
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-bundle"]) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function(event) {
        console.log('>>> Presale product check initiated BUNDLE');
        const isPreSaleProduct = document.getElementById('shopify-is-presale-product')?.value;

        const variantDataElements = document.querySelectorAll(".bundle-product-variants");

        const normalPrice = document.querySelector(".bundle--price .price__container > span:nth-child(5) > s")
        const totalPriceElement = document.querySelector(".bundle--price .price__container > div.price__sale > span.price-item.price-item--sale.price-item--last.pdp-price");

        // --- Leemos el metafield del bundle ---
        const bundleConfigEl = document.getElementById("bundle-config-json");
        const bundleConfig = bundleConfigEl ? JSON.parse(bundleConfigEl.textContent) : null;

        // Convertimos descuentos a un arreglo con los mismos índices de productos
        const discounts = bundleConfig ? bundleConfig.items.map(item => ({
            amount: item.amount,
            preSaleAmount: item.preSaleAmount,
            type: item.type
        })) : [];

        const bundleProducts = Array.from(variantDataElements).map((el, index) => ({
            index: index,
            variants: JSON.parse(el.textContent)
        }));	

        if (global_configs.isPreSaleEnabled) {

            if (isPreSaleProduct == true || isPreSaleProduct == 'true') {
                // Selecciona todos los inputs con ese name específico
                const presaleInputs = document.querySelectorAll('input[name="properties[_presale_discount]"]');

                presaleInputs.forEach((input, index) => {
                    input.value = "true";
                    console.log(`>>> Presale input ${index + 1} set to true`);
                });
            }
        }

        updateBundleTotal(bundleProducts, discounts, totalPriceElement,normalPrice);
    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-pim-v1"]) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function(event) {

	 	addPromoBadgesToPDPGallery();

		const showPromoPriceElement = document.getElementById("shopify-show-promo-price");
		const titleElement = document.querySelector(".product__title h1");
		const productTypeElement = document.getElementById("shopify-product-type");
		const regularPriceElement = document.querySelector(".price-item.price-item--regular.pdp-price");
		const isPreSaleProduct = document.getElementById('shopify-is-presale-product').value;
		const productTypeInput = document.getElementById("imp-product-type");

		if (!showPromoPriceElement || !titleElement || !productTypeElement || !regularPriceElement) {
			console.error('[PDP Init] Missing required DOM elements for pricing initialization.');
			updateTotalAddCart();
			return;
		}

		const showPromoPrice = showPromoPriceElement.value;
		const model = titleElement.textContent.trim().split(" ").pop();
		const productType = productTypeElement.value;
		const isPreSaleProductEnabled = String(isPreSaleProduct).toLowerCase() === 'true';
		const isPreSaleContext = global_configs.isPreSaleEnabled && isPreSaleProductEnabled;

		if (isPreSaleContext) {
			const presaleInput = document.getElementById("imp-pre-sale-input");
			if (presaleInput) {
				presaleInput.value = "true";
			}
		}

		if (showPromoPrice !== 'true') {
			if (isPreSaleContext) {
				updateDiscountBadge(model, 'presale');
			} else {
				updateDiscountBadge(model);
			}

			updateTotalAddCart();
			return;
		}

		if (productTypeInput) {
			productTypeInput.value = productType;
		}

		const htmlPrice = regularPriceElement.textContent;
		const discountedPrice = isPreSaleContext
			? getDiscountedPrice(model, htmlPrice, 'presale')
			: getDiscountedPrice(model, htmlPrice);
		const badgeCopy = isPreSaleContext ? global_configs._pre_sale_label : 'On Sale';

		renderPdpDiscountedPrice(regularPriceElement, htmlPrice, discountedPrice, badgeCopy);

        updateTotalAddCart();
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-v3-35i-modules"]) return;
  try {
    

	 	 document.addEventListener('DOMContentLoaded', function(event) {

			let productTitle 	 	 = document.querySelector(".product__title h1").textContent;
			const productType 	 = document.getElementById("shopify-product-type").value;
			const isPreSaleProduct = document.getElementById('shopify-is-presale-product').value;

			if(global_configs.isPreSaleEnabled) {

				let productTitle = document.querySelector(".product__title h1").textContent;

				// PRESALE - CONFIG - 4
				if(isPreSaleProduct) {
					let el = document.querySelector(".price-item.price-item--regular.pdp-price");

					const presaleInput = document.getElementById("imp-pre-sale-input");
					const productTypeInput  = document.getElementById("imp-product-type");

					productTypeInput.value = productType;

					let configuredDiscount;
					let htmlPrice = el.textContent

					if(productTitle.toLowerCase().includes('75i') && global_configs.is75iPreSale) {
						configuredDiscount = global_configs._75iDiscount.split(",");
						presaleInput.value = "true";
					} else if (productTitle.toLowerCase().includes('45i') && global_configs.is45iPreSale) {
						configuredDiscount = global_configs._45iDiscount.split(",");
						presaleInput.value = "true";
					} else if (productTitle.toLowerCase().includes('35i') && global_configs.is35iPreSale) {
						configuredDiscount = global_configs._35iDiscount.split(",");
						presaleInput.value = "true";
					} else if (productTitle.toLowerCase().includes('flex') && global_configs.isFlexPreSale) {
						configuredDiscount = global_configs._flexDiscount.split(",");
						presaleInput.value = "true";
					}

					if(configuredDiscount.length > 1) {
						discountedPrice = `$${formatPrice(htmlPrice,configuredDiscount[0],configuredDiscount[1])}`;

						el.innerHTML = `${discountedPrice} <strike style="color:gray; font-size:20px; font-weight: 300;" data-class="is-showing">${htmlPrice}</strike>`;

						const newSpan = document.createElement('span');

						newSpan.innerHTML = global_configs._pre_sale_label;
						newSpan.className = 'badge';

						newSpan.style.backgroundColor = 'var(--orange)';
						newSpan.style.color = 'white';
						newSpan.style.marginLeft = '10px';

						el.parentNode.appendChild(newSpan);
					}

					//helperCheckProductCards();
				}

				setTimeout(() => {
					const pdpBarPriceEl = document.querySelector('.sticky-pdp-bar__product-price');
					const pdpBarColPriceEl = document.querySelector('.h1.pdp-sticky-bar__product-price');

					let discoveryPriceText = pdpBarPriceEl.textContent.trim();
					let discoveryPrice = parseFloat(discoveryPriceText.replace('$', ''));

					let stickyPriceText = pdpBarColPriceEl.textContent.trim();
					let stickyPrice = parseFloat(stickyPriceText.replace('$', ''));

					let discountData;
					let productSuffix;

					if (productTitle.toLowerCase().includes('75i')) {
						discountData = global_configs._75iDiscount.split(",");
						productSuffix = '75i';
					}

					if (productTitle.toLowerCase().includes('45i')) {
						discountData = global_configs._45iDiscount.split(",");
						productSuffix = '45i';
					}

					if (productTitle.toLowerCase().includes('35i')) {
						discountData = global_configs._35iDiscount.split(",");
						productSuffix = '35i';
					}

					if(discountData.length) {
						htmlPrice = `$${formatPrice(stickyPriceText, discountData[0], discountData[1])} <strike id="discovery-pdp-price-${productSuffix}" style="color:gray;" data-class="is-showing" class="product-price--compared js-product-compare-price inline-block mls compare-price--grid ">${stickyPriceText}</strike>`;

						pdpBarPriceEl.innerHTML = htmlPrice;
						pdpBarColPriceEl.innerHTML = htmlPrice;
					}


				}, 1000);

			}
		});

  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-v3-35i"]) return;
  try {
    

	 	 document.addEventListener('DOMContentLoaded', function(event) {

			let productTitle 	 	 = document.querySelector(".product__title h1").textContent;
			const productType 	 = document.getElementById("shopify-product-type").value;
			const isPreSaleProduct = document.getElementById('shopify-is-presale-product').value;

			if(global_configs.isPreSaleEnabled) {

				let productTitle = document.querySelector(".product__title h1").textContent;

				// PRESALE - CONFIG - 4
				if(isPreSaleProduct) {
					let el = document.querySelector(".price-item.price-item--regular.pdp-price");

					const presaleInput = document.getElementById("imp-pre-sale-input");
					const productTypeInput  = document.getElementById("imp-product-type");

					productTypeInput.value = productType;

					let configuredDiscount;
					let htmlPrice = el.textContent

					if(productTitle.toLowerCase().includes('75i') && global_configs.is75iPreSale) {
						configuredDiscount = global_configs._75iDiscount.split(",");
						presaleInput.value = "true";
					} else if (productTitle.toLowerCase().includes('45i') && global_configs.is45iPreSale) {
						configuredDiscount = global_configs._45iDiscount.split(",");
						presaleInput.value = "true";
					} else if (productTitle.toLowerCase().includes('35i') && global_configs.is35iPreSale) {
						configuredDiscount = global_configs._35iDiscount.split(",");
						presaleInput.value = "true";
					} else if (productTitle.toLowerCase().includes('flex') && global_configs.isFlexPreSale) {
						configuredDiscount = global_configs._flexDiscount.split(",");
						presaleInput.value = "true";
					}

					if(configuredDiscount.length > 1) {
						discountedPrice = `$${formatPrice(htmlPrice,configuredDiscount[0],configuredDiscount[1])}`;

						el.innerHTML = `${discountedPrice} <strike style="color:gray; font-size:20px; font-weight: 300;" data-class="is-showing">${htmlPrice}</strike>`;

						const newSpan = document.createElement('span');

						newSpan.innerHTML = global_configs._pre_sale_label;
						newSpan.className = 'badge';

						newSpan.style.backgroundColor = 'var(--orange)';
						newSpan.style.color = 'white';
						newSpan.style.marginLeft = '10px';

						el.parentNode.appendChild(newSpan);
					}

					//helperCheckProductCards();
				}

				setTimeout(() => {
					const pdpBarPriceEl = document.querySelector('.sticky-pdp-bar__product-price');
					const pdpBarColPriceEl = document.querySelector('.h1.pdp-sticky-bar__product-price');

					let discoveryPriceText = pdpBarPriceEl.textContent.trim();
					let discoveryPrice = parseFloat(discoveryPriceText.replace('$', ''));

					let stickyPriceText = pdpBarColPriceEl.textContent.trim();
					let stickyPrice = parseFloat(stickyPriceText.replace('$', ''));

					let discountData;
					let productSuffix;

					if (productTitle.toLowerCase().includes('75i')) {
						discountData = global_configs._75iDiscount.split(",");
						productSuffix = '75i';
					}

					if (productTitle.toLowerCase().includes('45i')) {
						discountData = global_configs._45iDiscount.split(",");
						productSuffix = '45i';
					}

					if (productTitle.toLowerCase().includes('35i')) {
						discountData = global_configs._35iDiscount.split(",");
						productSuffix = '35i';
					}

					if(discountData.length) {
						htmlPrice = `$${formatPrice(stickyPriceText, discountData[0], discountData[1])} <strike id="discovery-pdp-price-${productSuffix}" style="color:gray;" data-class="is-showing" class="product-price--compared js-product-compare-price inline-block mls compare-price--grid ">${stickyPriceText}</strike>`;

						pdpBarPriceEl.innerHTML = htmlPrice;
						pdpBarColPriceEl.innerHTML = htmlPrice;
					}


				}, 1000);

			}
		});

  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-v3-45i"]) return;
  try {
    

	 	 document.addEventListener('DOMContentLoaded', function(event) {

			let productTitle 	 	 = document.querySelector(".product__title h1").textContent;
			const productType 	 = document.getElementById("shopify-product-type").value;
			const isPreSaleProduct = document.getElementById('shopify-is-presale-product').value;

			if(global_configs.isPreSaleEnabled) {

				let productTitle = document.querySelector(".product__title h1").textContent;

				// PRESALE - CONFIG - 4
				if(isPreSaleProduct) {
					let el = document.querySelector(".price-item.price-item--regular.pdp-price");

					const presaleInput = document.getElementById("imp-pre-sale-input");
					const productTypeInput  = document.getElementById("imp-product-type");

					productTypeInput.value = productType;

					let configuredDiscount;
					let htmlPrice = el.textContent

					if(productTitle.toLowerCase().includes('75i') && global_configs.is75iPreSale) {
						configuredDiscount = global_configs._75iDiscount.split(",");
						presaleInput.value = "true";
					} else if (productTitle.toLowerCase().includes('45i') && global_configs.is45iPreSale) {
						configuredDiscount = global_configs._45iDiscount.split(",");
						presaleInput.value = "true";
					} else if (productTitle.toLowerCase().includes('35i') && global_configs.is35iPreSale) {
						configuredDiscount = global_configs._35iDiscount.split(",");
						presaleInput.value = "true";
					} else if (productTitle.toLowerCase().includes('flex') && global_configs.isFlexPreSale) {
						configuredDiscount = global_configs._flexDiscount.split(",");
						presaleInput.value = "true";
					}

					if(configuredDiscount.length > 1) {
						discountedPrice = `$${formatPrice(htmlPrice,configuredDiscount[0],configuredDiscount[1])}`;

						el.innerHTML = `${discountedPrice} <strike style="color:gray; font-size:20px; font-weight: 300;" data-class="is-showing">${htmlPrice}</strike>`;

						const newSpan = document.createElement('span');

						newSpan.innerHTML = global_configs._pre_sale_label;
						newSpan.className = 'badge';

						newSpan.style.backgroundColor = 'var(--orange)';
						newSpan.style.color = 'white';
						newSpan.style.marginLeft = '10px';

						el.parentNode.appendChild(newSpan);
					}

					//helperCheckProductCards();
				}

				setTimeout(() => {
					const pdpBarPriceEl = document.querySelector('.sticky-pdp-bar__product-price');
					const pdpBarColPriceEl = document.querySelector('.h1.pdp-sticky-bar__product-price');

					let discoveryPriceText = pdpBarPriceEl.textContent.trim();
					let discoveryPrice = parseFloat(discoveryPriceText.replace('$', ''));

					let stickyPriceText = pdpBarColPriceEl.textContent.trim();
					let stickyPrice = parseFloat(stickyPriceText.replace('$', ''));

					let discountData;
					let productSuffix;

					if (productTitle.toLowerCase().includes('75i')) {
						discountData = global_configs._75iDiscount.split(",");
						productSuffix = '75i';
					}

					if (productTitle.toLowerCase().includes('45i')) {
						discountData = global_configs._45iDiscount.split(",");
						productSuffix = '45i';
					}

					if (productTitle.toLowerCase().includes('35i')) {
						discountData = global_configs._35iDiscount.split(",");
						productSuffix = '35i';
					}

					if(discountData.length) {
						htmlPrice = `$${formatPrice(stickyPriceText, discountData[0], discountData[1])} <strike id="discovery-pdp-price-${productSuffix}" style="color:gray;" data-class="is-showing" class="product-price--compared js-product-compare-price inline-block mls compare-price--grid ">${stickyPriceText}</strike>`;

						pdpBarPriceEl.innerHTML = htmlPrice;
						pdpBarColPriceEl.innerHTML = htmlPrice;
					}


				}, 1000);

			}
		});

  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-v3-75i"]) return;
  try {
    

	 	 document.addEventListener('DOMContentLoaded', function(event) {

			let productTitle 	 	 = document.querySelector(".product__title h1").textContent;
			const productType 	 = document.getElementById("shopify-product-type").value;
			const isPreSaleProduct = document.getElementById('shopify-is-presale-product').value;

			if(global_configs.isPreSaleEnabled) {

				let productTitle = document.querySelector(".product__title h1").textContent;

				// PRESALE - CONFIG - 4
				if(isPreSaleProduct) {
					let el = document.querySelector(".price-item.price-item--regular.pdp-price");

					const presaleInput = document.getElementById("imp-pre-sale-input");
					const productTypeInput  = document.getElementById("imp-product-type");

					productTypeInput.value = productType;

					let configuredDiscount;
					let htmlPrice = el.textContent

					if(productTitle.toLowerCase().includes('75i') && global_configs.is75iPreSale) {
						configuredDiscount = global_configs._75iDiscount.split(",");
						presaleInput.value = "true";
					} else if (productTitle.toLowerCase().includes('45i') && global_configs.is45iPreSale) {
						configuredDiscount = global_configs._45iDiscount.split(",");
						presaleInput.value = "true";
					} else if (productTitle.toLowerCase().includes('35i') && global_configs.is35iPreSale) {
						configuredDiscount = global_configs._35iDiscount.split(",");
						presaleInput.value = "true";
					} else if (productTitle.toLowerCase().includes('flex') && global_configs.isFlexPreSale) {
						configuredDiscount = global_configs._flexDiscount.split(",");
						presaleInput.value = "true";
					}

					if(configuredDiscount.length > 1) {
						discountedPrice = `$${formatPrice(htmlPrice,configuredDiscount[0],configuredDiscount[1])}`;

						el.innerHTML = `${discountedPrice} <strike style="color:gray; font-size:20px; font-weight: 300;" data-class="is-showing">${htmlPrice}</strike>`;

						const newSpan = document.createElement('span');

						newSpan.innerHTML = global_configs._pre_sale_label;
						newSpan.className = 'badge';

						newSpan.style.backgroundColor = 'var(--orange)';
						newSpan.style.color = 'white';
						newSpan.style.marginLeft = '10px';

						el.parentNode.appendChild(newSpan);
					}

					//helperCheckProductCards();
				}

				setTimeout(() => {
					const pdpBarPriceEl = document.querySelector('.sticky-pdp-bar__product-price');
					const pdpBarColPriceEl = document.querySelector('.h1.pdp-sticky-bar__product-price');

					let discoveryPriceText = pdpBarPriceEl.textContent.trim();
					let discoveryPrice = parseFloat(discoveryPriceText.replace('$', ''));

					let stickyPriceText = pdpBarColPriceEl.textContent.trim();
					let stickyPrice = parseFloat(stickyPriceText.replace('$', ''));

					let discountData;
					let productSuffix;

					if (productTitle.toLowerCase().includes('75i')) {
						discountData = global_configs._75iDiscount.split(",");
						productSuffix = '75i';
					}

					if (productTitle.toLowerCase().includes('45i')) {
						discountData = global_configs._45iDiscount.split(",");
						productSuffix = '45i';
					}

					if (productTitle.toLowerCase().includes('35i')) {
						discountData = global_configs._35iDiscount.split(",");
						productSuffix = '35i';
					}

					if(discountData.length) {
						htmlPrice = `$${formatPrice(stickyPriceText, discountData[0], discountData[1])} <strike id="discovery-pdp-price-${productSuffix}" style="color:gray;" data-class="is-showing" class="product-price--compared js-product-compare-price inline-block mls compare-price--grid ">${stickyPriceText}</strike>`;

						pdpBarPriceEl.innerHTML = htmlPrice;
						pdpBarColPriceEl.innerHTML = htmlPrice;
					}


				}, 1000);

			}
		});

  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-v3-infographics"]) return;
  try {
    

	 	 document.addEventListener('DOMContentLoaded', function(event) {

			let productTitle 	 	 = document.querySelector(".product__title h1").textContent;
			const productType 	 = document.getElementById("shopify-product-type").value;
			const isPreSaleProduct = document.getElementById('shopify-is-presale-product').value;

			if(global_configs.isPreSaleEnabled) {

				let productTitle = document.querySelector(".product__title h1").textContent;

				// PRESALE - CONFIG - 4
				if(isPreSaleProduct) {
					let el = document.querySelector(".price-item.price-item--regular.pdp-price");

					const presaleInput = document.getElementById("imp-pre-sale-input");
					const productTypeInput  = document.getElementById("imp-product-type");

					productTypeInput.value = productType;

					let configuredDiscount;
					let htmlPrice = el.textContent

					if(productTitle.toLowerCase().includes('75i') && global_configs.is75iPreSale) {
						configuredDiscount = global_configs._75iDiscount.split(",");
						presaleInput.value = "true";
					} else if (productTitle.toLowerCase().includes('45i') && global_configs.is45iPreSale) {
						configuredDiscount = global_configs._45iDiscount.split(",");
						presaleInput.value = "true";
					} else if (productTitle.toLowerCase().includes('35i') && global_configs.is35iPreSale) {
						configuredDiscount = global_configs._35iDiscount.split(",");
						presaleInput.value = "true";
					} else if (productTitle.toLowerCase().includes('flex') && global_configs.isFlexPreSale) {
						configuredDiscount = global_configs._flexDiscount.split(",");
						presaleInput.value = "true";
					}

					if(configuredDiscount.length > 1) {
						discountedPrice = `$${formatPrice(htmlPrice,configuredDiscount[0],configuredDiscount[1])}`;

						el.innerHTML = `${discountedPrice} <strike style="color:gray; font-size:20px; font-weight: 300;" data-class="is-showing">${htmlPrice}</strike>`;

						const newSpan = document.createElement('span');

						newSpan.innerHTML = global_configs._pre_sale_label;
						newSpan.className = 'badge';

						newSpan.style.backgroundColor = 'var(--orange)';
						newSpan.style.color = 'white';
						newSpan.style.marginLeft = '10px';

						el.parentNode.appendChild(newSpan);
					}

					//helperCheckProductCards();
				}

				setTimeout(() => {
					const pdpBarPriceEl = document.querySelector('.sticky-pdp-bar__product-price');
					const pdpBarColPriceEl = document.querySelector('.h1.pdp-sticky-bar__product-price');

					let discoveryPriceText = pdpBarPriceEl.textContent.trim();
					let discoveryPrice = parseFloat(discoveryPriceText.replace('$', ''));

					let stickyPriceText = pdpBarColPriceEl.textContent.trim();
					let stickyPrice = parseFloat(stickyPriceText.replace('$', ''));

					let discountData;
					let productSuffix;

					if (productTitle.toLowerCase().includes('75i')) {
						discountData = global_configs._75iDiscount.split(",");
						productSuffix = '75i';
					}

					if (productTitle.toLowerCase().includes('45i')) {
						discountData = global_configs._45iDiscount.split(",");
						productSuffix = '45i';
					}

					if (productTitle.toLowerCase().includes('35i')) {
						discountData = global_configs._35iDiscount.split(",");
						productSuffix = '35i';
					}

					if(discountData.length) {
						htmlPrice = `$${formatPrice(stickyPriceText, discountData[0], discountData[1])} <strike id="discovery-pdp-price-${productSuffix}" style="color:gray;" data-class="is-showing" class="product-price--compared js-product-compare-price inline-block mls compare-price--grid ">${stickyPriceText}</strike>`;

						pdpBarPriceEl.innerHTML = htmlPrice;
						pdpBarColPriceEl.innerHTML = htmlPrice;
					}


				}, 1000);

			}
		});

  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-v3"]) return;
  try {
    

	 	 document.addEventListener('DOMContentLoaded', function(event) {

		 	addPromoBadgesToPDPGallery();

			let productTitle 	 	 = document.querySelector(".product__title h1").textContent;
			const productType 	 = document.getElementById("shopify-product-type").value;
			const isPreSaleProduct = document.getElementById('shopify-is-presale-product').value;

			if(global_configs.isPreSaleEnabled) {

				let productTitle = document.querySelector(".product__title h1").textContent;

				// PRESALE - CONFIG - 4
				if(isPreSaleProduct) {
					let el = document.querySelector(".price-item.price-item--regular.pdp-price");

					const presaleInput = document.getElementById("imp-pre-sale-input");
					const productTypeInput  = document.getElementById("imp-product-type");

					productTypeInput.value = productType;

					let configuredDiscount;
					let htmlPrice = el.textContent

					if(productTitle.toLowerCase().includes('75i') && global_configs.is75iPreSale) {
						configuredDiscount = global_configs._75iDiscount.split(",");
						presaleInput.value = "true";
                      let productMediaBadge = document.getElementsByClassName("media_promo_badge")[0];
                productMediaBadge.style.display = "block";
					} else if (productTitle.toLowerCase().includes('45i') && global_configs.is45iPreSale) {
						configuredDiscount = global_configs._45iDiscount.split(",");
						presaleInput.value = "true";
                      let productMediaBadge = document.getElementsByClassName("media_promo_badge")[0];
                productMediaBadge.style.display = "block";
					} else if (productTitle.toLowerCase().includes('35i') && global_configs.is35iPreSale) {
						configuredDiscount = global_configs._35iDiscount.split(",");
						presaleInput.value = "true";
					} else if (productTitle.toLowerCase().includes('flex') && global_configs.isFlexPreSale) {
						configuredDiscount = global_configs._flexDiscount.split(",");
						presaleInput.value = "true";
					}

					if(configuredDiscount.length > 1) {
						discountedPrice = `$${formatPrice(htmlPrice,configuredDiscount[0],configuredDiscount[1])}`;

						el.innerHTML = `${discountedPrice} <strike style="color:gray; font-size:20px; font-weight: 300;" data-class="is-showing">${htmlPrice}</strike>`;

						let elBadges = document.querySelector(".price-badges");
						const newSpan = document.createElement('span');

						newSpan.innerHTML = global_configs._pre_sale_label;
						newSpan.className = 'badge';

						newSpan.style.backgroundColor = 'var(--orange)';
						newSpan.style.color = 'white';
						newSpan.style.marginLeft = '10px';

						elBadges.prepend(newSpan);
					}

					//helperCheckProductCards();
				}

				setTimeout(() => {
					const pdpBarPriceElements = document.querySelectorAll('.h1.pdp-sticky-bar__product-price');
					const mobilePdpPriceEl    = document.getElementById('mobile-pdp-normal-price');
					let discountedPrice;

					if (!pdpBarPriceElements.length) return;

					let discountData;
					let productSuffix;

					if (productTitle.toLowerCase().includes('75i')) {
						discountData = global_configs._75iDiscount?.split(",");
						productSuffix = '75i';
					} else if (productTitle.toLowerCase().includes('45i')) {
						discountData = global_configs._45iDiscount?.split(",");
						productSuffix = '45i';
					} else if (productTitle.toLowerCase().includes('35i')) {
						discountData = global_configs._35iDiscount?.split(",");
						productSuffix = '35i';
					}

					if (!discountData?.length) return;

					pdpBarPriceElements.forEach(element => {
						const stickyPriceText = element.textContent.trim();

						discountedPrice = `$${formatPrice(stickyPriceText, discountData[0], discountData[1])}`;
						const htmlPrice = getDiscountedPriceHTML(stickyPriceText, discountedPrice, productSuffix, `discovery-pdp-price-${productSuffix}`);

						element.innerHTML = htmlPrice;
					});

					mobilePdpPriceEl.innerHTML = getMobileDiscountedPriceHTML(mobilePdpPriceEl.textContent.trim(), discountedPrice);
				}, 1000);

			}
		});

  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-v4"]) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function(event) {

		addPromoBadgesToPDPGallery();

        const showPromoPrice = document.getElementById("shopify-show-promo-price").value;    
        
        const productTitle 	 	 = document.querySelector(".product__title h1").textContent;
        const model = productTitle.trim().split(" ").pop();
        
        const productType 	 = document.getElementById("shopify-product-type").value;
        const isPreSaleProduct = document.getElementById('shopify-is-presale-product').value;
        
        const el = document.querySelector(".price-item.price-item--regular.pdp-price");
        
        
        if(global_configs.isPreSaleEnabled) {
            // PRESALE - CONFIG - 4
            if(isPreSaleProduct) {
                
                let presaleInput = document.getElementById("imp-pre-sale-input");
                if(document.getElementById('imp-pre-sale-input')) {
                    presaleInput.value = "true"; 
                } else {
                    let presaleInput = document.getElementById("imp-pre-sale-input");
                    presaleInput.value = "true";
                }
                
                if(showPromoPrice !== 'true') {
                    const priceElements = document.getElementsByClassName("shopify-discount-badge-dc");
                    const discountMessage = getDiscountBadge(model,'presale');

                    if (priceElements.length > 0 && discountMessage) {
                        Array.from(priceElements).forEach((priceElement) => {
                            priceElement.appendChild(discountMessage);
                        });
                    }

                    return;
                }

                const productTypeInput  = document.getElementById("imp-product-type");
                let htmlPrice = el.textContent

                const discountedPrice = getDiscountedPrice(model,htmlPrice,'presale');

                productTypeInput.value = productType;

                if(discountedPrice === null || discountedPrice === undefined || discountedPrice === '') {
                    el.innerHTML = `${htmlPrice}`;
                } else {
                    el.innerHTML = `${discountedPrice} <strike style="color:gray; font-size:20px; font-weight: 300;" data-class="is-showing">${htmlPrice}</strike>`;
                    
                    const newSpan = document.createElement('span');
                    
                    newSpan.innerHTML = global_configs._pre_sale_label;
                    newSpan.className = 'badge';
                    
                    newSpan.style.backgroundColor = 'var(--orange)';
                    newSpan.style.color = 'white';
                    newSpan.style.marginLeft = '10px';
                    
                    el.parentNode.appendChild(newSpan);
                }
            }
        } else {

            if(showPromoPrice !== 'true') {
                const priceElements = document.getElementsByClassName("shopify-discount-badge-dc");
                const discountMessage = getDiscountBadge(model);

                if (priceElements.length > 0 && discountMessage) {
                    Array.from(priceElements).forEach((priceElement) => {
                        priceElement.appendChild(discountMessage);
                    });
                }
                return;
            }

            const productTypeInput  = document.getElementById("imp-product-type");
            
            let htmlPrice = el.textContent

            const discountedPrice = getDiscountedPrice(model,htmlPrice);

            productTypeInput.value = productType;

            if(discountedPrice === null || discountedPrice === undefined || discountedPrice === '') {
                el.innerHTML = `${htmlPrice}`;
            } else {
                el.innerHTML = `${discountedPrice} <strike style="color:gray; font-size:20px; font-weight: 300;" data-class="is-showing">${htmlPrice}</strike>`;
                
                const newSpan = document.createElement('span');
                
                newSpan.innerHTML = 'On Sale';
                newSpan.className = 'badge';
                
                newSpan.style.backgroundColor = 'var(--orange)';
                newSpan.style.color = 'white';
                newSpan.style.marginLeft = '10px';
                
                el.parentNode.appendChild(newSpan);
            }
        }

        updateTotalAddCart();
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-v5"]) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function(event) {

		addPromoBadgesToPDPGallery();

        const showPromoPrice = document.getElementById("shopify-show-promo-price").value;
        
        const productTitle 	 	 = document.querySelector(".product__title h1").textContent;
        const model = productTitle.trim().split(" ").pop();
        
        const productType 	 = document.getElementById("shopify-product-type").value;
        const isPreSaleProduct = document.getElementById('shopify-is-presale-product').value;
        
        const el = document.querySelector(".price-item.price-item--regular.pdp-price");
		const elMobilePrice = document.getElementById("mobile-pdp-normal-price");

        if(global_configs.isPreSaleEnabled) {
            // PRESALE - CONFIG - 4
            if(isPreSaleProduct) {
                
                let presaleInput = document.getElementById("imp-pre-sale-input");
                if(document.getElementById('imp-pre-sale-input')) {
                    presaleInput.value = "true"; 
                } else {
                    let presaleInput = document.getElementById("imp-pre-sale-input");
                    presaleInput.value = "true";
                }
                
                if(showPromoPrice !== 'true') {
                    const priceElements = document.getElementsByClassName("shopify-discount-badge-dc");
					console.log(">>> PRICEElements ", priceElements);
                    const discountMessage = getDiscountBadge(model,'presale');

                    if (priceElements.length > 0 && discountMessage) {
                        Array.from(priceElements).forEach((priceElement) => {
                            priceElement.appendChild(discountMessage);
                        });
                    }

                    return;
                }

                const productTypeInput  = document.getElementById("imp-product-type");
                let htmlPrice = el.textContent

                const discountedPrice = getDiscountedPrice(model,htmlPrice,'presale');

                productTypeInput.value = productType;

                if(discountedPrice === null || discountedPrice === undefined || discountedPrice === '') {
                    el.innerHTML = `${htmlPrice}`;
					if(elMobilePrice) {
						elMobilePrice.innerHTML = `${htmlPrice}`;
					}
                } else {
                    el.innerHTML = `${discountedPrice} <strike style="color:gray; font-size:20px; font-weight: 300;" data-class="is-showing">${htmlPrice}</strike>`;
					if(elMobilePrice) {
						elMobilePrice.innerHTML = `${discountedPrice} <strike style="color:gray; font-size:20px; font-weight: 300;" data-class="is-showing">${htmlPrice}</strike>`;
					}

                    const newSpan = document.createElement('span');
                    
                    newSpan.innerHTML = global_configs._pre_sale_label;
                    newSpan.className = 'badge';
                    
                    newSpan.style.backgroundColor = 'var(--orange)';
                    newSpan.style.color = 'white';
                    newSpan.style.marginLeft = '10px';
                    
                    el.parentNode.appendChild(newSpan);

					if(elMobilePrice) {
						elMobilePrice.parentNode.appendChild(newSpan.cloneNode(true));
					}
                }
            }
        } else {

            if(showPromoPrice !== 'true') {
                const priceElements = document.getElementsByClassName("shopify-discount-badge-dc");
				console.log(">>> PRICE ELEMENTS 2: ", priceElements);
                const discountMessage = getDiscountBadge(model);

                if (priceElements.length > 0 && discountMessage) {
                    Array.from(priceElements).forEach((priceElement) => {
                        priceElement.appendChild(discountMessage);
                    });
                }
                return;
            }

            const productTypeInput  = document.getElementById("imp-product-type");
            
            let htmlPrice = el.textContent

            const discountedPrice = getDiscountedPrice(model,htmlPrice);

            productTypeInput.value = productType;

            if(discountedPrice === null || discountedPrice === undefined || discountedPrice === '') {
                el.innerHTML = `${htmlPrice}`;
				if(elMobilePrice) {
					elMobilePrice.innerHTML = `${htmlPrice}`;
				}
            } else {
                el.innerHTML = `${discountedPrice} <strike style="color:gray; font-size:20px; font-weight: 300;" data-class="is-showing">${htmlPrice}</strike>`;
				if(elMobilePrice) {
					elMobilePrice.innerHTML = `${discountedPrice} <strike style="color:gray; font-size:20px; font-weight: 300;" data-class="is-showing">${htmlPrice}</strike>`;
				}

                const newSpan = document.createElement('span');
                
                newSpan.innerHTML = 'On Sale';
                newSpan.className = 'badge';
                
                newSpan.style.backgroundColor = 'var(--orange)';
                newSpan.style.color = 'white';
                newSpan.style.marginLeft = '10px';
                
                el.parentNode.appendChild(newSpan);
            }
        }

        updateTotalAddCart();
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-v6"]) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function(event) {

	 	addPromoBadgesToPDPGallery();

        const showPromoPrice = document.getElementById("shopify-show-promo-price").value;

        const productTitle 	 	 = document.querySelector(".product__title h1").textContent;
        const model = productTitle.trim().split(" ").pop();

        const productType 	 = document.getElementById("shopify-product-type").value;
        const isPreSaleProduct = document.getElementById('shopify-is-presale-product').value;

        const el = document.querySelector(".price-item.price-item--regular.pdp-price");


        if(global_configs.isPreSaleEnabled) {
            // PRESALE - CONFIG - 4
            if(isPreSaleProduct) {

                let presaleInput = document.getElementById("imp-pre-sale-input");
                if(document.getElementById('imp-pre-sale-input')) {
                    presaleInput.value = "true";
                } else {
                    let presaleInput = document.getElementById("imp-pre-sale-input");
                    presaleInput.value = "true";
                }

                if(showPromoPrice !== 'true') {
                    const priceElements = document.getElementsByClassName("shopify-discount-badge-dc");
                    const discountMessage = getDiscountBadge(model,'presale');

                    if (priceElements.length > 0 && discountMessage) {
                        Array.from(priceElements).forEach((priceElement) => {
                            priceElement.appendChild(discountMessage);
                        });
                    }

                    return;
                }

                const productTypeInput  = document.getElementById("imp-product-type");
                let htmlPrice = el.textContent

                const discountedPrice = getDiscountedPrice(model,htmlPrice,'presale');

                productTypeInput.value = productType;

                if(discountedPrice === null || discountedPrice === undefined || discountedPrice === '') {
                    el.innerHTML = `${htmlPrice}`;
                } else {
                    el.innerHTML = `${discountedPrice} <strike style="color:gray; font-size:20px; font-weight: 300;" data-class="is-showing">${htmlPrice}</strike>`;

                    const newSpan = document.createElement('span');

                    newSpan.innerHTML = global_configs._pre_sale_label;
                    newSpan.className = 'badge';

                    newSpan.style.backgroundColor = 'var(--orange)';
                    newSpan.style.color = 'white';
                    newSpan.style.marginLeft = '10px';

                    el.parentNode.appendChild(newSpan);
                }
            }
        } else {

            if(showPromoPrice !== 'true') {
                const priceElements = document.getElementsByClassName("shopify-discount-badge-dc");
                const discountMessage = getDiscountBadge(model);

                if (priceElements.length > 0 && discountMessage) {
                    Array.from(priceElements).forEach((priceElement) => {
                        priceElement.appendChild(discountMessage);
                    });
                }
                return;
            }

            const productTypeInput  = document.getElementById("imp-product-type");

            let htmlPrice = el.textContent

            const discountedPrice = getDiscountedPrice(model,htmlPrice);

            productTypeInput.value = productType;

            if(discountedPrice === null || discountedPrice === undefined || discountedPrice === '') {
                el.innerHTML = `${htmlPrice}`;
            } else {
                el.innerHTML = `${discountedPrice} <strike style="color:gray; font-size:20px; font-weight: 300;" data-class="is-showing">${htmlPrice}</strike>`;

                const newSpan = document.createElement('span');

                newSpan.innerHTML = 'On Sale';
                newSpan.className = 'badge';

                newSpan.style.backgroundColor = 'var(--orange)';
                newSpan.style.color = 'white';
                newSpan.style.marginLeft = '10px';

                el.parentNode.appendChild(newSpan);
            }
        }

        updateTotalAddCart();
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
	document.addEventListener('DOMContentLoaded', function(event) {

		let currentProductTitle	= document.querySelector(".product__title h1").textContent;
		let productTitle 	 	 = document.querySelector(".product__title h1").textContent;
		const productType 	 = document.getElementById("shopify-product-type").value;
		const isPreSaleProduct = document.getElementById('shopify-is-presale-product').value;

		if(global_configs.isPreSaleEnabled) {
				let productTitle = document.querySelector(".product__title h1").textContent;

				if(currentProductTitle.includes('Bundle PS')){
					let currentBadge = document.querySelector(".price__badge-sale");
					currentBadge.textContent = global_configs._pre_sale_label;
				}

				// PRESALE - CONFIG - 4
				if(isPreSaleProduct) {
					let el = document.querySelector(".price-item.price-item--regular.pdp-price");

					const presaleInput = document.getElementById("imp-pre-sale-input");
					const productTypeInput  = document.getElementById("imp-product-type");

					productTypeInput.value = productType;

					let configuredDiscount;
					let htmlPrice = el.textContent

					if(productTitle.toLowerCase().includes('75i') && global_configs.is75iPreSale) {
						configuredDiscount = global_configs._75iDiscount.split(",");
						presaleInput.value = "true";
					} else if (productTitle.toLowerCase().includes('45i') && global_configs.is45iPreSale) {
						configuredDiscount = global_configs._45iDiscount.split(",");
						presaleInput.value = "true";
					} else if (productTitle.toLowerCase().includes('35i') && global_configs.is35iPreSale) {
						configuredDiscount = global_configs._35iDiscount.split(",");
						presaleInput.value = "true";
					} else if (productTitle.toLowerCase().includes('flex') && global_configs.isFlexPreSale) {
						configuredDiscount = global_configs._flexDiscount.split(",");
						presaleInput.value = "true";
					}

					if(configuredDiscount.length > 1) {
						discountedPrice = `$${formatPrice(htmlPrice,configuredDiscount[0],configuredDiscount[1])}`;

						el.innerHTML = `${discountedPrice} <strike style="color:gray; font-size:20px; font-weight: 300;" data-class="is-showing">${htmlPrice}</strike>`;

						const newSpan = document.createElement('span');

						newSpan.innerHTML = global_configs._pre_sale_label;
						newSpan.className = 'badge';

						newSpan.style.backgroundColor = 'var(--orange)';
						newSpan.style.color = 'white';
						newSpan.style.marginLeft = '10px';

						el.parentNode.appendChild(newSpan);
					}

					//helperCheckProductCards();
				}

				setTimeout(() => {
					const pdpBarPriceEl = document.querySelector('.sticky-pdp-bar__product-price');
					const pdpBarColPriceEl = document.querySelector('.h1.pdp-sticky-bar__product-price');

					let discoveryPriceText = pdpBarPriceEl.textContent.trim();
					let discoveryPrice = parseFloat(discoveryPriceText.replace('$', ''));

					let stickyPriceText = pdpBarColPriceEl.textContent.trim();
					let stickyPrice = parseFloat(stickyPriceText.replace('$', ''));

					let discountData;
					let productSuffix;

					if (productTitle.toLowerCase().includes('75i')) {
						discountData = global_configs._75iDiscount.split(",");
						productSuffix = '75i';
					}

					if (productTitle.toLowerCase().includes('45i')) {
						discountData = global_configs._45iDiscount.split(",");
						productSuffix = '45i';
					}

					if (productTitle.toLowerCase().includes('35i')) {
						discountData = global_configs._35iDiscount.split(",");
						productSuffix = '35i';
					}

					if(discountData.length) {
						htmlPrice = `$${formatPrice(stickyPriceText, discountData[0], discountData[1])} <strike id="discovery-pdp-price-${productSuffix}" style="color:gray;" data-class="is-showing" class="product-price--compared js-product-compare-price inline-block mls compare-price--grid ">${stickyPriceText}</strike>`;

						pdpBarPriceEl.innerHTML = htmlPrice;
						pdpBarColPriceEl.innerHTML = htmlPrice;
					}


				}, 1000);

			}
	});

  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function(event) {
		if(global_configs.isPreSaleEnabled) {
			helperCheckProductCards();
		}
  });

  } catch(e) { console.error(e); }
})();
})();
